<template>
    <div class="image-container">
        <div class="carousel" v-show="imageLoaded && !imageError">
            <img class="loading" />
        </div>
        <img style="width: 100%;" :class="imageLoaded ? 'dispaly-node' : ''" :src="imageSrc" @load="onImageLoaded"
            @error="onImageError" :alt="img_alt" />
        <img class="error_img" style="width: 100%;" :class="imageError ? '' : 'dispaly-node'" src="../assets/img/erro.jpg" alt="error" />
    </div>
</template>
  
<script>
export default {
    props: ['imageSrc','altText'],
    data() {
        return {
            imageLoaded: true,
            imageError: false,
        };
    },
    computed:{
        img_alt() {
            return this.altText || '轮播图';

        },
    },
    methods: {
        onImageLoaded() {
            this.imageLoaded = false;
        },
        onImageError() {
            this.imageError = true;
        }
    }
};
</script>
  
<style scoped>
.dispaly-node {
    display: none;
}



.loading {
    position: relative;
    width: 30px;
    height: 30px;
    border: 2px solid #000;
    border-top-color: rgba(0, 0, 0, 0.2);
    border-right-color: rgba(0, 0, 0, 0.2);
    border-bottom-color: rgba(0, 0, 0, 0.2);
    border-radius: 100%;
    /* margin-top: -30px; */
    margin-left: -15px;
    right: 50%;
    left: 50%;
    top: 50%;
    animation: circle infinite 0.75s linear;
}

@keyframes circle {
    0% {
        transform: rotate(0);
    }

    100% {
        transform: rotate(360deg);
    }
}

@media only screen and (min-width : 993px) {
    .carousel {
        height: 480px;
    }
    .error_img{
        height: 480px;
    }
}

@media only screen and (max-width : 992px) {

    .carousel {
        height: 360px;
    }
    .error_img{
        height: 360px;
    }
}

@media only screen and (max-width:1199px) {
    .carousel {
    height: 570px;
}
.error_img{
        height: 570px;
    }
}

@media only screen and (max-width : 767px) {
    .carousel {
        height: 207px;
    }
    .error_img{
        height: 207px;
    }
}
</style>
  